import { AlertTriangle, Mail, Phone, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

interface CompanySuspendedProps {
  reason?: string | null;
}

export const CompanySuspended = ({ reason }: CompanySuspendedProps) => {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-muted/30 p-4">
      <div className="max-w-lg w-full text-center space-y-6">
        {/* Ícone de Alerta */}
        <div className="mx-auto w-24 h-24 rounded-full bg-destructive/10 flex items-center justify-center animate-pulse">
          <AlertTriangle className="h-12 w-12 text-destructive" />
        </div>

        {/* Título */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">Acesso Suspenso</h1>
          <p className="text-xl text-muted-foreground">
            O acesso da sua empresa ao GOnX foi temporariamente suspenso.
          </p>
        </div>

        {/* Motivo (se disponível) */}
        {reason && (
          <div className="bg-destructive/5 border border-destructive/20 rounded-lg p-4">
            <p className="text-sm text-muted-foreground mb-1">Motivo:</p>
            <p className="text-foreground font-medium">{reason}</p>
          </div>
        )}

        {/* Instruções */}
        <div className="bg-muted/50 rounded-lg p-6 text-left space-y-4">
          <p className="text-sm text-muted-foreground">
            Se você acredita que isso é um erro ou deseja regularizar sua situação, 
            entre em contato com nosso suporte:
          </p>
          
          <div className="space-y-3">
            <a 
              href="mailto:suporte@gonx.com.br"
              className="flex items-center gap-3 text-primary hover:underline"
            >
              <Mail className="h-5 w-5" />
              <span>suporte@gonx.com.br</span>
            </a>
            
            <a 
              href="https://wa.me/5511999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-primary hover:underline"
            >
              <Phone className="h-5 w-5" />
              <span>WhatsApp: (11) 99999-9999</span>
            </a>
          </div>
        </div>

        {/* Botão de Logout */}
        <Button
          variant="outline"
          onClick={signOut}
          className="gap-2"
        >
          <LogOut className="h-4 w-4" />
          Sair da Conta
        </Button>

        {/* Rodapé */}
        <p className="text-xs text-muted-foreground">
          GOnX - Sistema de Gestão Empresarial
        </p>
      </div>
    </div>
  );
};
